import axios from "axios";
import { API_ENDPOINTS } from "Constants";


// eslint-disable-next-line import/no-anonymous-default-export
export default {
  multipleFileUpload: (data) => {
    return axios.post(API_ENDPOINTS.MULTI_IMAGE_FILE_UPLOAD, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data",
      },
    });
  },
  singleFileUpload: (data) => {
    data = data[0];
    return axios.post(API_ENDPOINTS.SINGLE_IMAGE_FILE_UPLOAD, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data",
      },
    });
  },
  profileimageupload: (data) => {
    const userID = data.get("userId"); // Retrieve userId from FormData
    const image = data.get("image"); // Retrieve the file
    
    //console.log("userId:", userID);
    //console.log("image:", image);
    return axios.put(API_ENDPOINTS.PROFILE_IMAGE_UPLOAD+'/'+userID, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data",
      },
    });
  },
  carimageupload: (data) => {
    const userID = data.get("userId"); // Retrieve userId from FormData
    const image = data.get("image"); // Retrieve the file
        console.log("userId:", userID);
    console.log("image:", image);

    return axios.put(API_ENDPOINTS.UPLOAD_VEHICLE_IMAGE+'/'+userID, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data",
      },
    });
  },
};
